export const VERIFY_OTP_LAMF = "VERIFY_OTP_LAMF";
export const VERIFY_OTP_LAMF_SUCCESS = "VERIFY_OTP_LAMF_SUCCESS";
export const VERIFY_OTP_LAMF_FAILURE = "VERIFY_OTP_LAMF_FAILURE";

export const GET_CLIENT_DATA_LAMF = "GET_CLIENT_DATA_LAMF";
export const GET_CLIENT_DATA_LAMF_SUCCESS = "GET_CLIENT_DATA_LAMF_SUCCESS";
export const GET_CLIENT_DATA_LAMF_FAILURE = "GET_CLIENT_DATA_LAMF_FAILURE";
